/* globals $ */
import { registerClass } from 'libs/ComponentLoader'
import Recommendations from 'libs/Recommendations'

import { PAGE_COMPONENTS_LOADED } from '_global/js/main'

import './styles.scss'

class ProductRecommendations {
  constructor (element) {
    this.$el = $(element)

    this.productCarousel = null

    let excludeIds = (this.$el[0].hasAttribute('data-exclude-ids')) ? this.$el.attr('data-exclude-ids').split(',') : []
    this.$el.find('.productCard').each((index, item) => {
      const productId = $(item).attr('data-product-id')
      if (productId) {
        excludeIds.push(productId)
      }
    })

    this.recommendations = new Recommendations({
      product: window.product,
      excludeIds: excludeIds
    })

    $(document).on(PAGE_COMPONENTS_LOADED, (e) => {
      this.productCarousel = this.$el.find('.productCarousel').data('component')
      if (this.productCarousel) {
        this.productCarousel.initCarousel({
          dataPromise: this.recommendations.getRecomendations
        })
      }
    })
  }
}

registerClass('ProductRecommendations', ProductRecommendations)
